import React, {useMemo} from 'react';
import {useTranslation} from "react-i18next";

import TableContainer from '../Communications/Table/TableContainer';
import DateFormated from "../../../Utils/Date/Date";
import Alert from "../../../UI/Alerts/Alert";
import BasicDataTable from "../../../Utils/BasicDataTable";


const OrderRepeat = (props) => {
    const {t, i18n} = useTranslation();
    const {subaccount, order, confirm, formValues,orderDefault} = props;

    const descAccessor = ((i18n.language === 'fr') ? 'descriptionFr' : 'descriptionEn');

    const inscreaseQty = (elem) => {
        let selector = document.getElementById(elem);
        selector.value = parseInt(selector.value) + 1;
        updateTotal();
    }
    const decreaseQty = (elem) => {
        let selector = document.getElementById(elem);
        if (parseInt(selector.value) - 1 >= 0) {
            selector.value = parseInt(selector.value) - 1;
            updateTotal();
        }
    }

    const columns = useMemo(
        () => [
            {
                Header: t('orders.details.table.headers.productnumber'),
                accessor: 'productCode.code',
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },
            {
                Header: t('orders.details.table.headers.vendor'),
                accessor: 'vendor',
                Cell: (props) => {
                    return props.row.original.harnoisProductCode.code;
                },
            },
            {
                Header: t('orders.details.table.headers.product'),
                accessor: 'productCode.' + descAccessor,
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },
            {
                Header: t('orders.details.table.headers.packaging'),
                accessor: 'productCode.packaging' /*'productCode.' + descAccessor*/,
                Cell: (props) => {
                    return props.row.original.productDescriptionLine2;
                },
            },
            {
                Header: <div className="a-center">{t('orders.details.table.headers.quantity')}</div>,
                accessor: 'requestedQuantity',
                Cell: (props) => {


                        let id = `product-${props.row.original.productCode.code}`;
                        return <div className="qty-updater d-flex">
                            <button className="btn btn--qty" onClick={() => decreaseQty(id)}><i
                                className="far fa-minus"/>
                            </button>
                            <input type="number" max="100000000" id={id} defaultValue={props.row.original.requestedQuantity}/>
                            <button className="btn btn--qty" onClick={() => inscreaseQty(id)}><i
                                className="far fa-plus"/>
                            </button>
                        </div>


                },
            },
        ],
        [t, i18n, order.lines]
    );
    const columnsConfirm = useMemo(
        () => [
            {
                Header: t('orders.details.table.headers.productnumber'),
                accessor: 'productCode.code',
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },
            {
                Header: t('orders.details.table.headers.product'),
                accessor: 'productCode.'+descAccessor,
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },
            {
                Header: t('orders.details.table.headers.quantity'),
                accessor: 'requestedQuantity',
                Cell: (props) => {
                    let qty = 0;
                    if(formValues.lines.length){
                        for(let i=0; i< formValues.lines.length; i++){
                            if(formValues.lines[i].productCode === props.row.original.productCode.code){
                                qty = formValues.lines[i].requestedQuantity;
                            }
                        }
                    }

                    return (qty != null)?parseFloat(qty).toFixed(2):"";
                    // sinon quantité demandé

                },
            },
        ],
        [t, i18n, formValues]
    );
    const updateTotal = () => {
        let total = 0;
        let counters = document.querySelectorAll(".qty-updater input");
        counters.forEach((counter) => {
            total += parseInt(counter.value)
        });
        document.getElementById('total-qty').innerHTML = total;
    }


    let modalContent = "";
    if(!confirm){
        let total;
        if (order.lines) {
            total = 0;
            order.lines.map((item, index) => {
                total += item.requestedQuantity
            })
        }
        modalContent = <form className="order__repeat" onSubmit={event => {
            event.preventDefault();
            event.nativeEvent.submitter.id === 'repeat-sender' ? props.actionConfirm(event, order, subaccount,orderDefault) : ''
        }
        } id="repeatorderform">
            <div className="row row--rmline mb-0">
                <div className="col-12 col-md-6 order__details__left">
                    <div className="order__subaccount subaccount modal__content__block">
                        <p>
                            <strong
                                className="subaccount__name">{subaccount.subAccountCode} - {subaccount.subAccountName}</strong><br/>
                            {(subaccount.address.addressLine1) &&
                            <span className="subaccount__address1">{subaccount.address.addressLine1}<br/></span>}
                            {(subaccount.address.addressLine2) &&
                            <span className="subaccount__address2">{subaccount.address.addressLine2}<br/></span>}
                            {(subaccount.address.city) &&
                            <span className="subaccount__city">{subaccount.address.city}<br/></span>}
                            {(subaccount.address.postalCode) &&
                            <span className="subaccount__postal-code">{subaccount.address.postalCode}</span>}
                        </p>
                    </div>
                    {order.printedNotes &&
                    <div className="order__notes modal__content__block">
                        <p>
                            <strong>{t('orders.details.instructions')}</strong><br/>
                            {order.printedNotes}
                        </p>
                    </div> }
                    <div className="order__status modal__content__block mb-4">
                        <p>
                            <strong>
                                {orderDefault.deliveryDelayMessage !== null ?
                                    i18n.language === "fr"
                                        ? orderDefault.deliveryDelayMessage.descriptionFr
                                        : orderDefault.deliveryDelayMessage.descriptionEn : ''}

                            </strong>
                        </p>
                        {
                            (order.orderStatus != 'C') &&
                            <Alert type="danger" item={{
                                type: 'danger',
                                additionalClasses: 'message--condensed message--delivery',
                                customIcon: 'fas fa-exclamation-triangle',
                                text: (i18n.language == 'fr')?orderDefault.deliveryFeeMessage.descriptionFr:orderDefault.deliveryFeeMessage.descriptionEn
                            }}/>
                        }
                    </div>
                </div>
                <div className="col-12 col-md-5 offset-md-1 order__details__right">
                    <div className="modal__content__block">
                        {orderDefault.creationDate !== "0001-01-01T00:00:00" && <div className="row row--rmline">
                            <div className="col-12">
                                <p><strong>{t('orders.details.date')}</strong><br/>
                                    <DateFormated date={orderDefault.creationDate} withTime={false}/></p>
                            </div>
                        </div>}
                        <div className="row row--rmline">
                            <div className="col-md-6">
                                <p className="order__data">
                                    <strong>{t('orders.details.deliverynumber')}</strong><br/>
                                    {order.deliveryNumber}
                                </p>
                            </div>
                            <div className="col-md-6">
                                <p className="order__data">
                                    <strong>{t('orders.details.pallets')}</strong><br/>
                                    {parseFloat(order.palletCount).toFixed(2)}
                                </p>
                            </div>
                            {/*
                                <div className="col-md-6">
                                <p className="order__data">
                                    <strong>{t('orders.details.weight')}</strong><br/>
                                    !!!MISSING DATA VALUE!!!
                                </p>
                            </div>
                                 */}
                        </div>
                        <div className="row row--rmline">
                            <div className="col-12">
                                <label htmlFor={'ordernumber'}
                                       className="input-field">{t("popuporder.ordernumber")}<br/>
                                    <input className="_full" type={'text'} name={'ordernumber'}
                                           defaultValue={order.poNumber}
                                           maxLength="16"
                                           placeholder=""/>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row row--rmline">
                <div className="col-12">
                    <div className="modal__content__block">
                        <BasicDataTable columns={columns} data={order.lines}/>
                        <div className="total-row">
                            <div className="total-row__inner d-flex justify-content-end">
                                <strong>Total</strong>
                                <div id="total-qty">{total}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row row--rmline">
                <div className="col-12">
                    <label htmlFor={'note'} className="input-field">{t("popuporder.shippingnote")}<br/>
                        <textarea name={'note'} className="_full" placeholder={t("popuporder.notecontent")}
                                  defaultValue={order.printedNotes}/>
                    </label>
                </div>
            </div>
        </form>
    }else{

        let total;
        if (formValues.lines) {
            total = 0;
            formValues.lines.map((item, index) => {
                total += item.requestedQuantity
            })
        }
        modalContent= <div>
            <div className="row row--rmline">
                <div className="message message--success message--condensed">
                    <div className="message__icon">
                        <i className="fas fa-check-circle"></i>
                    </div>
                    <div className="message__content">
                        <div>
                            <span>{t('popuporder.success_message.line1')}</span> <strong
                            className="p--c-black">{t('popuporder.success_message.line2')}</strong>
                            <span
                                className="p--c-black">{' '}#{props.response.data.orderId}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row row--rmline mb-0">
                <div className="col-12 col-md-6 order__details__left">
                    <div className="order__subaccount subaccount modal__content__block">
                        <p>
                            <strong
                                className="subaccount__name">{subaccount.subAccountCode} - {subaccount.subAccountName}</strong><br/>
                            {(subaccount.address.addressLine1) &&
                            <span className="subaccount__address1">{subaccount.address.addressLine1}<br/></span>}
                            {(subaccount.address.addressLine2) &&
                            <span className="subaccount__address2">{subaccount.address.addressLine2}<br/></span>}
                            {(subaccount.address.city) &&
                            <span className="subaccount__city">{subaccount.address.city}<br/></span>}
                            {(subaccount.address.postalCode) &&
                            <span className="subaccount__postal-code">{subaccount.address.postalCode}</span>}
                        </p>
                    </div>
                    <div className="order__notes modal__content__block mb-4">
                        <p>
                            <strong>{t('orders.details.instructions')}</strong><br/>
                            {(order.printedNotes) ? order.printedNotes : ''}
                        </p>
                    </div>

                </div>
                <div className="col-12 col-md-4 offset-md-2 order__details__right">
                    <div className="modal__content__block">
                        {/* <div className="row row--rmline">
                            <div className="col-md-6">
                                <p className="order__data">
                                    <strong>{t('orders.details.deliverynumber')}</strong><br/>
                                    {order.deliveryNumber}
                                </p>
                            </div>

                                <div className="col-md-6">
                                <p className="order__data">
                                    <strong>{t('orders.details.weight')}</strong><br/>
                                    !!!MISSING DATA VALUE!!!
                                </p>
                            </div>

                        </div> */}

                        <div className="row row--rmline">
                            <div className="col-12">
                                <label htmlFor={'ordernumber'}
                                       className="input-field">{t("popuporder.ordernumber")}<br/>
                                </label>
                                <div>{formValues.purchaseOrderNumber}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row row--rmline">
                <div className="col-12">
                    <div className="modal__content__block">
                        <BasicDataTable columns={columnsConfirm} data={order.lines}/>

                        <div className="total-row">
                            <div className="total-row__inner d-flex justify-content-end">
                                <strong>Total</strong>
                                <div id="total-qty" style={{minWidth:"194px"}}>{total}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row row--rmline">
                <div className="col-12">
                    <label htmlFor={'note'} className="input-field">{t("popuporder.shippingnote_short")}<br/>
                        <p>{formValues.deliveryNote}</p>
                    </label>
                </div>
            </div>
        </div>
    }



    return (
        modalContent
    );
};

export default OrderRepeat;
